<style>
    td,th {
        padding: 15px;
        text-align: left;
    }

    th {
        padding-top: 0px;
    }

    td {
        border-top: 1px solid whitesmoke;
    }

    tr {
        cursor: pointer;
    }

    tr:hover {
        background-color: whitesmoke; 
    }

    .type-badge {
        padding: 5px;
        border-radius: 10px;
        color: white;
        font-size: 12px;
        display: inline-block;
        line-height: 1em;
        width: 90px;
        text-align: center;
    }
</style>

<script>
    import {onMount} from 'svelte'
    import * as Common from '../Common.js'
    import {push} from '../pt-router/Router.svelte'

    export let goToItem // function (item_id)

    export let item
    export let currentUserArea
    let pollOptions = null

    onMount(() => {
        if(item.item_type == Common.ITEMTYPE_POLL) {
            Common.getData('item/poll/'+item.item_id)
            .then(data => {
                if(!data) {
                    return
                }

                pollOptions = data
            })
        }
    })

    function toggleArchiveItem(e, item_id) {
        e.stopPropagation()
        Common.postData("tools/area/" + currentUserArea.id + "/archiveitem/" + item_id)
        .then(r => {
            if(!r.ok) {
                    Common.CreateNotification({body: "Problem removing or restoring item from map."}, 1000)
                return
            }
            if(!item.item_archived) {
                Common.CreateNotification({body: "Item Removed From Map."}, 1000)
            } else {
                Common.CreateNotification({body: "Item Restored To Map."}, 1000)
            }

            item.item_archived = !item.item_archived
        })
    }
</script>

<tr id={item.item_id} on:click={() => goToItem(item.item_id)}>
    <td>{item.item_id}</td>
    <td style="white-space: nowrap">{Common.UnixTimeToDateStr(item.item_createtime)}</td>
    <td>
        <div class="type-badge" style={"background-color:" + Common.getItemTypeColorString(item.item_type) + ";"}>
            {Common.getItemTypeString(item.item_type)}
        </div>
    </td>
    <td>{item.item_title}</td>
    <td>{item.item_likes}</td>
    <td>
        {item.item_comments.length} {(item.item_comments.length == 1) ? 'comment' : 'comments'}
        {#if pollOptions}
            <span style="padding-left: 15px">{pollOptions.reduce((tot,n) => tot + n.votes, 0)} {(pollOptions.reduce((tot,n) => tot + n.votes, 0) == 1) ? 'vote' : 'votes'}</span>
        {/if}
    </td>
    <td>
        <button on:click={(e) => toggleArchiveItem(e, item.item_id)}>
    
            {#if !item.item_archived}Remove From Map{:else}Restore to Map{/if}
        </button>
    </td>
</tr>